import { memo, useMemo } from 'react';
import { useArticleLargeCarPagedRedirect } from '@pages/articles/articlePage/helpers.ts';
import { ArticleDropMenu } from '@features/articles/article-card/menu/index.ts';
import { OpenIndicatorWithImage } from '@features/common/open-indicator/index.ts';
import { SmallCard } from '@features/common/SmallCard/ArticleAndProgramCard';
import { SmallCardStatus } from '@features/common/SmallCardStatus/index.tsx';
import { getInitialM } from '@shared/helpers/index.ts';
import { useUser } from '@shared/hooks/index.ts';
import { type Article } from '@shared/types/articles';
import type { ActiveTabType } from '@shared/types/common';
import * as st from './styles.module.scss';

interface Props {
  article: Article;
  onRedirect?: () => void;
  needDropDawnShowUp?: boolean;
  activeTab?: ActiveTabType;
  className?: string;
}

export const ArticleCardSmall = memo(
  ({ article, activeTab, onRedirect, needDropDawnShowUp, className }: Props) => {
    const {
      id,
      // costs,
      opened,
      publication,
      moderation_status,
      // is_paid,
      favorite,
      // cost_base,
      author,
      title,
    } = article;

    const { doRedirectWithSavePageUrl } = useArticleLargeCarPagedRedirect();
    const authorName = useMemo(
      () => getInitialM(author.first_name, author.middle_name, author.last_name),
      [author]
    );
    // const authorName = `${author.last_name}.${author.first_name[0]}.${author?.middle_name[0]}`;

    const { user } = useUser();

    const isAuthor = useMemo(() => author.id === user?.id, [author, user]);
    const onCardClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
      e.preventDefault();
      onRedirect && onRedirect();
      doRedirectWithSavePageUrl(`${id}`);
    };

    return (
      <SmallCard
        className={className}
        title={title}
        authorName={authorName}
        onCardClick={onCardClick}
        openIndicatorNode={
          <OpenIndicatorWithImage
            activeTab={activeTab}
            isAuthor={isAuthor}
            isOpened={opened}
            isPublished={publication?.is_published || false}
            modStatus={moderation_status}
            onClick={onCardClick}
            imgSrc={article.cover}
          />
        }
        smallCardStatusNode={
          <SmallCardStatus
            className={st.status}
            moderationStatus={moderation_status}
            isAuthor={isAuthor}
            isPublished={publication?.is_published}
            isPaid={true}
            isFavorite={favorite}
          />
        }
        menuNode={
          <ArticleDropMenu
            id={id}
            needDropDawnShowUp={needDropDawnShowUp}
            isAuthor={isAuthor}
            isFavorite={favorite}
            authorId={author?.coach?.id}
            // isPaid={is_paid}
          />
        }
      />
    );
  }
);
